<!-- eslint-disable prettier/prettier -->
<template>
  <v-dialog v-model="contractRequestRefuseDialog" style="width:100%;" class="fill-height" transition="dialog-transition"
    persistent scrollable fullscreen>
    <template slot="activator">
      <p v-show="selectedProductsLength" class="text-xs-center px-2 py-2 ma-0">
        <span style="font-size:16px; font-weight:normal; color: white;">
          Gesamtpreis<span v-show="selectedProductsLength < 4"> bisher</span>: {{ priceTotal }} Euro
        </span>
      </p>
      <v-btn v-show="selectedProductsLength" block dark class="cta">
        <strong>
          Das will ich!
        </strong>
      </v-btn>
    </template>

    <v-card color="#CCD5ED">
      <v-toolbar dark color="#002EA7">
        <v-toolbar-title v-if="dataInputIsComplete">Gegenstände versichern</v-toolbar-title>
        <v-toolbar-title v-if="!dataInputIsComplete">Hinweis</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="contractRequestRefuseDialog = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <!-- Hinweis: Wenige Produkte ausgewählt -->
      <v-card-text class="alertContainer" v-if="selectedProductsLength < 3">
        <v-alert :value="true" type="info" :dismissible="dataInputIsComplete" color="primary" outline>
          Achtung! Sie können bis zu vier Gegenstände versichern. Den vierten Gegenstand
          sogar für 0 Euro!
        </v-alert>
      </v-card-text>
      <!-- Hinweis: Drei Produkte ausgewählt, viertes Gratis -->
      <v-card-text v-if="selectedProductsLength == 3">
        <v-alert :value="true" type="info" :dismissible="dataInputIsComplete" color="primary" outline>
          Sie haben drei Gegenstände ausgewählt. Den vierten Gegenstand können Sie
          für 0 Euro versichern!
        </v-alert>
      </v-card-text>
      <!-- Hinweis: Eingaben unvollständig -->
      <v-card-text v-if="!dataInputIsComplete">
        <v-alert :value="true" type="error" color="primary" outline>
          Bitte die Beschreibung zu jedem Gegenstand vervollständigen. Danke!
        </v-alert>
      </v-card-text>

      <!-- Antrag-Stecke -->
      <v-card-text id="dialogScrollContainer" v-if="dataInputIsComplete">
        <form-offer-request v-if="!dataInputSummaryAvailable"
          @showSummary="dataInputSummaryAvailable = true; scrollDialogToTop();"></form-offer-request>
        <form-offer-request-summary v-if="dataInputSummaryAvailable" @contractSuccess="handleContractSuccess"
          @coming-back="dataInputSummaryAvailable = false; scrollDialogToTop();"></form-offer-request-summary>
      </v-card-text>
      <!-- ENDE Antrag-Strecke -->
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import FormOfferRequest from "./FormOfferRequest";
import FormOfferRequestSummary from "./FormOfferRequestSummary";
import { postGaMessage } from "@/stores/modules/ga";
import { documentDefinition } from "../libs/pdf/pdfmakeDocDefs";
import { footerFunction } from "../libs/pdf/widgets/footer";
import { headerFunction } from "../libs/pdf/widgets/header";
import { add, format, parseISO } from "date-fns";

export default {
  name: "DialogContractRequest",
  components: { FormOfferRequestSummary, FormOfferRequest },
  data() {
    return {
      contractRequestRefuseDialog: false,
      dataInputSummaryAvailable: false
    };
  },
  watch: {
    contractRequestRefuseDialog() {
      if (this.contractRequestRefuseDialog) {
        const label = this.dataInputIsComplete
          ? "Das will ich: Beschreibung vollständig"
          : "Das will ich: Beschreibung unvollständig";
        postGaMessage("nextStep", label);
      }
    },
    dataInputSummaryAvailable: function() {
      // If Data-Input is complete and dataInputSummaryAvailable changes from false to true:
      // then call the CheckService
      if (this.dataInputSummaryAvailable) {
      }
    },
    selectedProductsLength: function() {
      this.$store.dispatch("work/postMessageNewHeight");
    },
    priceTotal: function() {
      // console.log("Der Gesamtpreis hat sich verändert.");
      this.$store.dispatch("work/postMessageNewPrice");
    }
  },
  computed: {
    ...mapGetters("work", {
      testExportData: "getExportData",
      selectedProductsLength: "getSelectedProductsLength",
      priceTotal: "getPriceTotal",
      dataInputIsComplete: "getDataInputReadyState",
      productsWithIncompleteDescription:
        "getListOfProductsWithIncompleteDescription",
      dataForDocumentService: "getExportDataForDocumentService"
    })
  },
  methods: {
    scrollDialogToTop() {
      document.getElementById("dialogScrollContainer").scrollTop = 0;
    },
    handleContractSuccess() {
      this.contractRequestRefuseDialog = false; // Schließt diesen Dialog
    }
  }
  /*
  doIt() {
    createMyPdf(this.enrichedDocumentDefinition());
  },
  enrichedDocumentDefinition() {
    let template = JSON.stringify(documentDefinition);
    const content = this.dataForDocumentService;
    // policyHeader
    template = template.replaceAll("__vnr__", content.offerRequest.contract.policy);
    template = template.replaceAll("__name__", content.offerRequest.policyholder.name);
    template = template.replaceAll("__lastname__", content.offerRequest.policyholder.lastname);
    template = template.replaceAll("__street__", content.offerRequest.policyholder.street);
    template = template.replaceAll("__housenr__", content.offerRequest.policyholder.housenr);
    template = template.replaceAll("__zip__", content.offerRequest.policyholder.zip);
    template = template.replaceAll("__city__", content.offerRequest.policyholder.city);
    // Allgemeine Vertragsangaben
    const now = parseISO(content.offerRequest.contract.beginn);
    const nowString = now.toLocaleDateString("de-DE");
    template = template.replaceAll("__beginn__", nowString);
    const ende = add(now, { years: 1 });
    const endeString = ende.toLocaleDateString("de-DE");
    template = template.replaceAll("__ende__", endeString);
    const payDay = format(now, 'd');
    if (payDay === '29' || payDay === '30' || payDay === '31') {
      payDay += ", bzw. am Monatsende, falls der Monat weniger Tage hat";
    }
    template = template.replaceAll("__trueBeginDateDay__", payDay);
  
    const check = this.createProductsTableDefinitions(
      content.offerRequest.contract.products
    );
    console.log("contract.products: ", content.offerRequest.contract.products);
    console.log("Produkte: ", JSON.stringify(check));
    template = template.replaceAll(
      "__selectedProducts__",
      JSON.stringify(check)
    );
    // cleanup
    template = template.replaceAll('"[[{', '[[{');
    template = template.replaceAll('}]]"', '}]]');
    // Tabellenwerte Beitragsberechnung
    const beitragBrutto = content.offerRequest.contract.gesamtbeitrag;
    const beitragNetto = Math.round(100 * (beitragBrutto / 1.19)) / 100;
    const versSteuer = Math.round(100 * (beitragBrutto - beitragNetto)) / 100;
    template = template.replaceAll("__beitragNetto__", new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2 }).format(beitragNetto));
    template = template.replaceAll("__versSteuer__", new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2 }).format(versSteuer));
    template = template.replaceAll("__beitragBrutto__", new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2 }).format(beitragBrutto));
    // Beitragsabrechnung
    // Ergänze Beginndatum, Folgedatum, FolgeFolgeDatum
    const folgeDatum = add(now, { months: 1 });
    const folgeFolgeDatum = add(folgeDatum, { months: 1 });
    const folgeDatumString = folgeDatum.toLocaleDateString("de-DE");
    const folgeFolgeDatumString = folgeFolgeDatum.toLocaleDateString("de-DE");
  
    template = template.replaceAll("__beginnDatum__", nowString);
    template = template.replaceAll("__folgeDatum__", folgeDatumString);
    template = template.replaceAll("__folgeFolgeDatum__", folgeFolgeDatumString);
    template = template.replaceAll("__IBAN__", this.obfuscateIban(content.offerRequest.policyholder.iban));
  
    const rich = JSON.parse(template);
    rich.footer = footerFunction;
    rich.header = headerFunction;
    return rich;
  },
  obfuscateIban(iban) {
    const lastFour = iban.substring(iban.length - 4);
    const firstFour = iban.substring(0, 4);
    let body = iban.substring(4, iban.length - 4);
    const obfuscated = body.replaceAll(/./g, "X");
    return firstFour + obfuscated + lastFour;
  },
  createProductsTableDefinitions(products) {
    let productsTableBody = [];
    products.forEach((product, index) => {
      productsTableBody.push([[], []]);
      productsTableBody[index][0] = {
        text: [
          { text: index + 1 + ". versicherter Gegenstand\n", bold: true },
          { text: "Kategorie:\t" + product.label + "\nHersteller/Modell:\t" + product.producer }
        ]
      };
      if (product.imei != "") {
        productsTableBody[index][0].text.push({ text: "\nIMEI:\t" + product.imei });
      }
      productsTableBody[index][1] = {};
      if (product.pictures && product.pictures.length > 0) {
        productsTableBody[index][1] = {
          image: product.pictures[0].data,
          fit: [50, 50]
        };
      }
    });
    return productsTableBody;
  }
  } */
};
</script>

<style>
.v-alert .v-icon {
  color: currentColor !important;
}

.v-alert.error {
  background-color: #ccd5ed !important;
  color: #002ea7 !important;
}

.v-dialog--scrollable > .v-card > .v-card__text.alertContainer {
  overflow-y: visible !important;
}
</style>
